import { Link as RouterLink } from 'react-router-dom';
import Link from '@mui/material/Link';
import Button from '@mui/material/Button';
import { useTheme } from "@mui/material";


export default function ButtonsMainGoTo({ to, name, onClick, state, sx: sxOverride, ...props }) {

  const theme = useTheme();

  return (

 theme.palette.mode === "light" ? (

<Link component={RouterLink} to={to} state={state}>

       <Button variant="outlined" size="large" onClick={onClick} {...props}

              sx={[{

                  minWidth: {xs: 80, sm: 90, md: 100, lg: 100, xl: 100},
                  mt:1,
                  py: 1.5,
                  //p: '10px 12px',
                  color: 'common.white',
                  bgcolor: 'greydark.C900',
                  borderColor: 'greydark.C900',
                  borderRadius: 7,
                  transition: 'transform 0.2s ease',

                  '&:hover': {
                  color: 'common.white',
                  bgcolor: 'greydark.C900',
                  borderColor: 'greydark.C900',
                  borderRadius: '20px',
                  transform: 'scale(1.2)',
                  },

                  '&.Mui-disabled': {
                    color: 'grey.600',
                    bgcolor: 'grey.300',
                    borderColor: 'grey.300',
                  },

                }, sxOverride]}>
          {name}
      </Button>
</Link>

  ) : (

 <Link component={RouterLink} to={to} state={state}>

      <Button variant="outlined" size="large" onClick={onClick} {...props}

            sx={[{

                minWidth: {xs: 80, sm: 90, md: 100, lg: 100, xl: 100},
                p: '10px 14px',
                color: 'common.black',
                bgcolor: 'grey.C200',
                borderColor: 'grey.C200',
                borderRadius: '20px',
                transition: 'transform 0.2s ease',

                '&:hover': {
                color: 'common.black',
                bgcolor: 'grey.C200',
                borderColor: 'grey.C200',
                transform: 'scale(1.2)',
                },

                '&.Mui-disabled': {
                  color: 'rgba(255, 255, 255, 0.5)',
                  bgcolor: 'rgba(255, 255, 255, 0.12)',
                  borderColor: 'rgba(255, 255, 255, 0.12)',
                },

              }, sxOverride]}
        >

        {name}

    </Button>
</Link>
  )

  );
}

